import styled from 'styled-components';
import {theme} from '@styles/theme';

export const CompareModuleName = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: space-between;
  padding: 8px 8px 8px 24px;
  gap: 4px;
`;

export const HoverInfo = styled.div`
  position: absolute;
  left: 0;
  top: 100%;
  transform: none;
  background: ${theme.colors.basic08};
  border-radius: ${theme.roundedBig};
  border-top-left-radius: 0;
  border: 1px solid ${theme.colors.basic04};
  padding: 8px 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  white-space: nowrap;
  z-index: 10;
  gap: 8px;
  display: flex;
  flex-direction: column;
`;

export const TableCell = styled.td`
  border: 1px solid ${theme.colors.basic06};
  position: relative;
  text-overflow: ellipsis;
  &:not(:first-child) {
    &:hover {
      background-color: ${theme.colors.basic07};
    }
  }
  &:first-child {
    width: 296px;
  }
`;

export const TestCellContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px;
`;

export const HoverInfoWrapper = styled.div``;
